package meineglasfaser.api.routes

import io.ktor.resources.*
import kotlinx.datetime.LocalDate
import kotlinx.serialization.Serializable
import meineglasfaser.api.*

@Resource("/shop")
class ShopRoutes {
    @Resource("/query")
    class Query(val parent: ShopRoutes = ShopRoutes()) {
        @Resource("/network-categories")
        class NetworkCategories(
            val customerType: CustomerType,
            val parent: Query = Query(),
        ) {
            @Serializable
            data class ResponseBody(
                val categories: List<ShopNetworkCategory>,
            )
        }

        @Resource("/networks")
        class Networks(
            val customerType: CustomerType,
            val networkCategoryId: String,
            val parent: Query = Query(),
        ) {
            @Serializable
            data class ResponseBody(
                val category: ShopNetworkCategory,
                val networks: List<ShopNetwork>,
            )
        }

        @Resource("/products")
        class Products(
            val customerType: CustomerType,
            val networkCategoryId: String,
            val networkId: String,
            val parent: Query = Query(),
        ) {
            @Serializable
            data class ResponseBody(
                val network: ShopNetwork,
                val products: List<Product>,
            )
        }

        @Resource("/product")
        class ProductQuery(
            val customerType: CustomerType,
            val networkCategoryId: String,
            val networkId: String,
            val productNid: Int,
            val parent: Query = Query(),
        ) {
            @Serializable
            data class ResponseBody(
                val product: Product,
                val addons: List<ShopAddonGroupWithProducts>,
            )
        }
    }

    @Resource("/basket")
    class Basket(val parent: ShopRoutes = ShopRoutes()) {
        @Resource("/compute")
        class Compute(val includeTax: Boolean, val parent: Basket = Basket())
    }

    @Resource("/order")
    class Order(val parent: ShopRoutes = ShopRoutes()) {
        @Serializable
        data class RequestBody(
            val basket: ShopBasket,
            val individualFirstName: String? = null,
            val individualLastName: String? = null,
            val individualDob: LocalDate? = null,
            val companyName: String? = null,
            val companyVatNumber: String? = null,
            val companyContactPerson: String? = null,
            val telFixedLine: String? = null,
            val telMobile: String? = null,
            val deliveryAddressStreetName: String = "",
            val deliveryAddressPostalZone: String = "",
            val deliveryAddressCityName: String = "",
            val deliveryAddressCountryCode: String = "",
            val invoicingAddressStreetName: String = "",
            val invoicingAddressPostalZone: String = "",
            val invoicingAddressCityName: String = "",
            val invoicingAddressCountryCode: String = "",
            val invoicingEmail: String? = null,
            val invoicingAccountHolder: String = "",
            val invoicingIBAN: String = "",
            val bankSepaConfirmation: Boolean = false,
            val termsConfirmation: Boolean = false,
            val privacyConfirmation: Boolean = false,
            val placementConfirmation: Boolean = false,
        )

        @Serializable
        data class ResponseBody(
            val orderId: String,
            val orderNid: Int,
        )
    }

    @Resource("/survey-types-with-options")
    class SurveyTypesWithOptions(val parent: ShopRoutes = ShopRoutes())

    @Resource("/survey-entry")
    class SurveyEntry(val parent: ShopRoutes = ShopRoutes()) {
        @Serializable
        data class RequestBody(
            val name: String,
            val email: String,
            val phone: String,
            val installationTypeId: String?,
            val installationOptionId: String?,
            val installationCount: Int,
            val installationAddressStreetName: String,
            val installationAddressPostalCode: String,
            val installationAddressCityName: String,
            val installationAddressCountryCode: String,
            val datenverarbeitungConfirmation: Boolean,
            val termsConfirmation: Boolean,
            val privacyConfirmation: Boolean,
            val grabungsarbeitenConfirmation: Boolean,
            val notes: String? = null,
        )
    }
}
